import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiError, ApiParameter, get, rawRequest, request } from "@insite/client-framework/Services/ApiService";

export interface DownloadTearSheetResultModel {
    result: any;
}

export interface DownloadTearSheetParameter extends ApiParameter {
    erpNumber?: string;
}

export const downloadTearSheetUrl = "/api/v2/downloadtearsheet";

export async function getDownloadTearSheet(parameter: DownloadTearSheetParameter) {
    const response = await fetch(`${downloadTearSheetUrl}?erpNumber=${parameter.erpNumber}`);

    try {
        const blob = response.ok && (await response.blob());
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return blob;
    } catch (error) {
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(downloadTearSheetUrl, response, message, errorJson);
    }
}
